/**
 * Too many concurrent uploads can cause high CPU load, and requests might time out.
 * Apparently 32 would be the optimum for a 7 Gbit connection, but that was measured using a native app.
 * Let's keep (MAX_CONCURRENT_UPLOADS * MAX_CONCURRENT_CHUNKS) around 8 or 16.
 * Initial value only; will be auto-adjusted by UploadManager.setMaxConcurrentUploadsAuto().
 */
export const MAX_CONCURRENT_UPLOADS = 8;

/**
 * Sets the maximum no. of chunks uploaded simultaneously within each file.
 * Works together with MAX_CONCURRENT_UPLOADS.
 * Initial value only; will be auto-adjusted by UploadManager.setMaxConcurrentUploadsAuto().
 */
export const MAX_CONCURRENT_CHUNKS = 2;

/**
 * Maximum number of queued uploads for the shared worker.
 * This does not limit the number of actual concurrent uploads (which is managed separately) and should be
 * multiple times larger than MAX_CONCURRENT_UPLOADS, but not too large to avoid excessive memory usage.
 */
export const MAX_SHARED_WORKER_QUEUE = 100;

/** Used for calculations from MiB to bytes and vice versa.  */
const ONE_MEBIBYTE = 1_048_576;

/** Minimum chunk size in bytes for uploads. Defined by us. Defaults to 1MiB. */
export const MINIMUM_CHUNK_SIZE = ONE_MEBIBYTE;

/** Chunk size in bytes for uploads. Defaults to 5MiB. */
export const DEFAULT_CHUNK_SIZE = 5_242_880;

/**
 * Callback type reporting that the upload has completed successfully
 *
 * @param id The ID the upload task has in the store.
 * @param fileName The name of the file
 * @param fileSize The size of the file
 * @param fileType The type of the file
 * @param downloadUrl The URL of the uploaded file at the remote location
 * @param md5 The hash of the uploaded file
 */

/**
 * Callback type reporting that the upload has failed
 *
 * @param id is the ID the upload task has in the store.
 * @param fileName is the name of the file.
 * @param error is the exception that was raised and made the upload fail.
 */

/**
 * Callback type reporting that the upload has progressed
 *
 * @param id is the ID the upload task has in the store.
 * @param progress is the new progress of the upload, measured from 0 to 100.
 */

/**
 * Callback type reporting that the upload was canceled
 *
 * @param id is the ID the upload task has in the store.
 * @param fileName is the name of the file.
 */

/** Function used to get a task from the store by its id */

/**
 *  Function used to notify an upload started to the React context to update the store
 *
 * @param id is the id of the task in the store
 * @param file is the handle to the file to upload
 * @param isSilent whether progress toast notifications should be hidden
 * @param context Additional information about the task
 */

/**
 * A type collecting the background task's properties that we may want
 * to update in the store
 */

/** Function used to notify an upload was updated to the React context to update the store */

/** Function used to notify an upload finished to the React context to remove the task from the store */

/** All the callbacks that can be passed to the upload manager */

/** Necessary properties without callbacks */

/** Necessary properties to upload file by upload manager */

/**
 * The interface of the object contained in the FileUploadsContext.
 *
 * WARNING: this type should not be used directly, it is just exported
 * as an implementation detail to realize the FileUploadContextProvider,
 * and the hooks useFileUploader and useCancelUpload.
 */

/** Response object for the progress message */

/** Response object for the complete message */

/** Response object for the failed Message */

/** Response object for the canceled message */

/** Response Messages of the shared worker. They are converted into callbacks */

/** Define FileUploadParamsReduced by omitting the coreApiClient */

/** A request message to the shared worker */